<style lang="less" scoped>
  @import "../../../assets/css/table-list.css";
  @import "../report.less";
</style>
<style lang="less">
  .report{
    .ivu-table-border td:nth-child(5) .ivu-table-cell,
    .ivu-table-border td:nth-child(6) .ivu-table-cell{
      padding:0;
      p{
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        padding:10px;
      }
    }
  }
</style>
<template>
  <div class="report">
    <h3 class="title">成都长城实业集团有限公司租金收入汇总表</h3>
    <div class="margin-bottom-10 header-group">
      <label>所属产权：</label>
      <Select v-model="d_ProjName_index" style="width: 200px;margin-right: 20px;" @on-change="change_name">
        <Option v-for="(item,index) in d_ProjName_arr" :value="item.value" :key="index">{{ item.label }}</Option>
      </Select>
      <label>当前年度：</label>
      <DatePicker :value="currYear" :clearable="false" type="year" placeholder="选择年限" style="width: 200px" @on-change="change_date"></DatePicker>
    </div>
    <section>
      <Table border :columns="d_columns" :data="d_data"></Table>
    </section>
  </div>
</template>
<script>
  import apiReport from '@/api/report.js';
  export default {
    name:'shopReport',
    data() {
      return {
        d_ProjName_label: '',
        currYear: this.to_date(new Date()).split('-')[0],
        d_ProjName_index:0,
        d_ProjName_arr:[],
        d_columns: [
          {
            type: 'index',
            width: 60,
            align: 'center'
          },
          {
            title: '合同编号',
            align: 'center',
            minWidth:160,
            key: 'SerialNum'
          },
          {
            title: '租赁地址',
            align: 'center',
            minWidth:200,
            key: 'Address'
          },
          {
            title: '面积',
            align: 'center',
            minWidth:100,
            render: (h, params) => {
              return h('span',params.row.Area?(params.row.Area+'m²'):'')
            }
          },
          {
            title: '承租单位',
            align: 'center',
            minWidth:160,
            key: 'BPartyName'
          },
          {
            title: '租赁时间',
            align: 'center',
            minWidth:160,
            render: (h, params) => {
              return h('span',params.row.BeginDate?(params.row.BeginDate+'至'+params.row.EndDate):'')
            }
          },
          {
            title: '交租方式',
            align: 'center',
            minWidth:160,
            key: 'CycleType'
          },
          {
            title: '租金/本年',
            align: 'center',
            minWidth:100,
            render: (h, params) => {
              return h('span',params.row.Zujinbennian?(params.row.Zujinbennian+'元'):'')
            }
          },
          {
            title: '月租（元）',
            align: 'center',
            minWidth:100,
            render: (h, params) => {
              if(params.row.MonthPriceDetail){
                let priceStr = params.row.MonthPriceDetail.split('月租');
                return h('span',priceStr[1].split('单价')[0]+'元')
              }else {
                return '';
              }
            }
          },
          {
            title: '保证金',
            align: 'center',
            key: 'AgreeDeposit',
            minWidth:100,
            render: (h, params) => {
              if(params.row.AgreeDeposit){
                return h('span',Number(params.row.AgreeDeposit)+Number(params.row.WaterDeposit)+'元')
              }else {
                return '';
              }
            }
          },
          {
            title: '应收合计',
            align: 'center',
            minWidth:100,
            render: (h, params) => {
              return h('span',params.row.Yinshouheji?(params.row.Yinshouheji+'元'):'')
            }
          },
          {
            title: '收租时间',
            align: 'center',
            children: [
              {
                title: '1月',
                minWidth:100,
                align: 'center',
                render: (h, params) => {
                  const MonthPrice = this.split_detail(params.row.MonthDetail,'01');
                  return h('span', (MonthPrice?MonthPrice:'0.00') +'元')
                }
              },
              {
                title: '2月',
                minWidth:100,
                align: 'center',
                render: (h, params) => {
                  const MonthPrice = this.split_detail(params.row.MonthDetail,'02');
                  return h('span', (MonthPrice?MonthPrice:'0.00') +'元')
                }
              },
              {
                title: '3月',
                minWidth:100,
                align: 'center',
                render: (h, params) => {
                  const MonthPrice = this.split_detail(params.row.MonthDetail,'03');
                  return h('span', (MonthPrice?MonthPrice:'0.00') +'元')
                }
              },
              {
                title: '4月',
                minWidth:100,
                align: 'center',
                render: (h, params) => {
                  const MonthPrice = this.split_detail(params.row.MonthDetail,'04');
                  return h('span', (MonthPrice?MonthPrice:'0.00') +'元')
                }
              },
              {
                title: '5月',
                minWidth:100,
                align: 'center',
                render: (h, params) => {
                  const MonthPrice = this.split_detail(params.row.MonthDetail,'05');
                  return h('span', (MonthPrice?MonthPrice:'0.00') +'元')
                }
              },
              {
                title: '6月',
                minWidth:100,
                align: 'center',
                render: (h, params) => {
                  const MonthPrice = this.split_detail(params.row.MonthDetail,'06');
                  return h('span', (MonthPrice?MonthPrice:'0.00') +'元')
                }
              },
              {
                title: '7月',
                minWidth:100,
                align: 'center',
                render: (h, params) => {
                  const MonthPrice = this.split_detail(params.row.MonthDetail,'07');
                  return h('span', (MonthPrice?MonthPrice:'0.00') +'元')
                }
              },
              {
                title: '8月',
                minWidth:100,
                align: 'center',
                render: (h, params) => {
                  const MonthPrice = this.split_detail(params.row.MonthDetail,'08');
                  return h('span', (MonthPrice?MonthPrice:'0.00') +'元')
                }
              },
              {
                title: '9月',
                minWidth:100,
                align: 'center',
                render: (h, params) => {
                  const MonthPrice = this.split_detail(params.row.MonthDetail,'09');
                  return h('span', (MonthPrice?MonthPrice:'0.00') +'元')
                }
              },
              {
                title: '10月',
                minWidth:100,
                align: 'center',
                render: (h, params) => {
                  const MonthPrice = this.split_detail(params.row.MonthDetail,'10');
                  return h('span', (MonthPrice?MonthPrice:'0.00') +'元')
                }
              },
              {
                title: '11月',
                minWidth:100,
                align: 'center',
                render: (h, params) => {
                  const MonthPrice = this.split_detail(params.row.MonthDetail,'11');
                  return h('span', (MonthPrice?MonthPrice:'0.00') +'元')
                }
              },
              {
                title: '12月',
                minWidth:100,
                align: 'center',
                render: (h, params) => {
                  const MonthPrice = this.split_detail(params.row.MonthDetail,'12');
                  return h('span', (MonthPrice?MonthPrice:'0.00') +'元')
                }
              }
            ]
          },
          {
            title: '已收合计',
            align: 'center',
            children: [
              {
                title: '累计',
                align: 'center',
                minWidth:100,
                render: (h, params) => {
                  return h('span',params.row.Yishouheji?(params.row.Yishouheji+'元'):'')
                }
              }
            ],
          },
          {
            title: '欠租累计',
            align: 'center',
            children: [
              {
                title: '累计',
                align: 'center',
                minWidth:100,
                render: (h, params) => {
                  return h('span',params.row.Qianzuleiji?(params.row.Qianzuleiji+'元'):'')
                }
              }
            ]
          }
        ],
        d_data: []
      };
    },
    methods: {
      split_detail(str,_month){
        if(str){
          let info = str.split(',');
          for(let i=0;i<info.length;i++){
            let monthStr = info[i].split('-');
            if(monthStr[1] ===_month){
              let priceStr = info[i].split(':');
              return priceStr[1];
            }
          }
        }else {
          return 0
        }

      },
      to_date(date){
        let moment = require('moment');
        return moment(date).format('YYYY-MM-DD');
      },
      change_name(value){
        this.d_ProjName_label = this.d_ProjName_arr[value].label;
        this.pull_data();
      },
      change_date(date){
        this.currYear = date;
        this.pull_data();
      },
      get_ProjName(){
        let _this = this;
        apiReport.getProjNameList().then((_data) => {
          if(_data.data.ExeSuccess && _data.data.LoginSuccess){
            let rowList= _data.data.Data;
            let arr = [];
            for(let i=0;i<rowList.length;i++){
              let param = {
                value: i,
                label: rowList[i]
              };
              arr.push(param);
            }
            this.d_ProjName_arr = arr;
            this.d_ProjName_index = 0;
            this.d_ProjName_label = arr[0].label;
            this.pull_data();
          }else {
            this.$Message.error(_data.data.Msg);
          }
        });
      },
      pull_data() {
        let _this = this;
        let projName = this.d_ProjName_label;
        if(!projName) return;
        apiReport.GetReport4(projName,this.currYear).then((_data) => {
          if(_data.data.ExeSuccess && _data.data.LoginSuccess){
            let requestResult = _data.data.Data;
            this.d_data = [];
            if(requestResult.length<=0) return;
              let sum = [];
              for(let i=0;i<requestResult.length;i++){
                if(requestResult[i].MonthDetail){
                  sum = sum.concat(requestResult[i].MonthDetail.split(','));
                }
              }
              let hist = sum.reduce(function (prev, item) {
                let d = item.split("-");
                let date = d[0] + d[1];
                if (date in prev)
                  prev[date].push(item)
                else
                  prev[date] = [item];
                return prev;
              }, {} );
              let detail = '';
              for(let i in hist) {
                let bbb = 0;
                let date111 = '';
                for(let j=0;j<hist[i].length;j++){
                  date111 = hist[i][j].split(':')[0];
                  let hah = Number(hist[i][j].split(':')[1]);
                  bbb += hah;
                }
                detail += date111+':'+bbb+',';
              }
              _this.d_data = requestResult;
              let lastTotal = {
                SerialNum:'合计',
                MonthDetail:detail
              };
              _this.d_data.push(lastTotal)

          }else {
            this.$Message.error(_data.data.Msg);
          }
        });
      }
    },
    created() {
      this.get_ProjName();
    },

    mounted(){

    }
  }
</script>
